document.addEventListener('DOMContentLoaded', function () {
    'use strict';

    document.querySelectorAll('.quote-swiper').forEach(function (swiperObject) {
        new Swiper(swiperObject.querySelector('.swiper'), {
            speed: 1000,
            loop: true,
            slidesPerView: 1,
            grabCursor: true,
            pagination: {
                el: swiperObject.querySelector('.swiper-pagination'),
            },
            navigation: {
                nextEl: swiperObject.querySelector('.swiper-button-next'),
                prevEl: swiperObject.querySelector('.swiper-button-prev'),
            },
        });
    });
});

//# sourceMappingURL=swiper-quote.js.map
